module.exports = __webpack_public_path__ + "img/LINK_2x.b82de21e.svg";